import { USGSA_TRACK_SOURCE } from "@/constants/horseRacing";
import { Hr_BettingInterest } from "@/graphql/gql/graphql";

type StructureT = "handicapping" | "timeform";

function sortByPick(
  bettingInterests: Hr_BettingInterest[],
  structure: StructureT
) {
  return bettingInterests.sort(
    ({ runners: runnersA }, { runners: runnersB }) =>
      (runnersA?.[0]?.[structure]?.freePick?.number ?? 0) -
      (runnersB?.[0]?.[structure]?.freePick?.number ?? 0)
  );
}

function filterBettingInterests(bettingInterests: Hr_BettingInterest[]) {
  return bettingInterests.filter(
    ({ runners }) =>
      runners?.[0]?.timeform?.freePick?.number ??
      runners?.[0]?.handicapping?.freePick?.number
  );
}

type RunnerPlus = Hr_BettingInterest & {
  pickProvider: "timeform" | "handicapping";
};
function filterPickSources(
  bettingInterests: Hr_BettingInterest[],
  trackDataSource: string
) {
  const pickSources = {
    timeform: [] as RunnerPlus[],
    handicapping: [] as RunnerPlus[],
  };

  bettingInterests.forEach((bi) => {
    const runner = bi.runners?.[0];

    if (runner?.timeform?.freePick?.number) {
      pickSources.timeform.push({ ...bi, pickProvider: "timeform" });
    }

    if (runner?.handicapping?.freePick?.number) {
      pickSources.handicapping.push({ ...bi, pickProvider: "handicapping" });
    }
  });

  if (
    trackDataSource === USGSA_TRACK_SOURCE &&
    pickSources.timeform.length &&
    pickSources.handicapping.length
  ) {
    return [
      sortByPick(pickSources.timeform, "timeform"),
      sortByPick(pickSources.handicapping, "handicapping"),
    ];
  }

  return [sortByPick(pickSources.handicapping, "handicapping")];
}

export default function filterPicksByDataSource(
  bettingInterests: Hr_BettingInterest[],
  trackDataSource: string
) {
  return filterPickSources(
    filterBettingInterests(bettingInterests),
    trackDataSource
  );
}
